import { create } from 'zustand';

interface SessionNavigationState {
  activeSessionId: string | null;
  showExitConfirmation: boolean;
  pendingRecorderOpen: boolean;

  setActiveSessionId: (sessionId: string) => void;
  clearActiveSession: () => void;
  setShowExitConfirmation: (show: boolean) => void;
  setPendingRecorderOpen: (pending: boolean) => void;
}

export const useSessionNavigationStore = create<SessionNavigationState>((set) => ({
  activeSessionId: null,
  showExitConfirmation: false,
  pendingRecorderOpen: false,

  setActiveSessionId: (sessionId) => set({ activeSessionId: sessionId }),
  clearActiveSession: () => set({ activeSessionId: null, showExitConfirmation: false, pendingRecorderOpen: false }),
  setShowExitConfirmation: (show) => set({ showExitConfirmation: show }),
  setPendingRecorderOpen: (pending) => set({ pendingRecorderOpen: pending }),
}));
